import { Auth } from "aws-amplify";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewUserRelationship } from "../../data/omniDataModel";
import * as AssessmentSession from "../redux/assessmentSession";
import * as Actions from "../redux/onboardingSession";
import * as PartnerSession from "../redux/partnerSession";
import * as UserSessionActions from "../redux/userSession";

export function* loadOnboardingODM({ payload }) {
  try {
    //clear out the existing information
    yield put(Actions.setOnboardingODMRequest(null));

    //Make sure ID is valid before calling this, it gets set when you call "setInviteKey, which knows not to call this if its not good."
    yield put(Actions.setOnboardingStatusRequest(null));

    let onboardingODM = yield call(OmniDataAPI.getOnboarding, payload);

    if (onboardingODM.hasOwnProperty("omniData")) {
      onboardingODM["inviteKey"] = payload;

      try {
        //onboardingHTML
        if (
          onboardingODM.omniData.hasOwnProperty("onboardingHTML") &&
          onboardingODM.omniData.onboardingHTML
        ) {
          yield put(Actions.setOnboardingHTMLRequest(onboardingODM.omniData.onboardingHTML));
        }

        //onboardingAssessment
        if (
          onboardingODM.omniData.hasOwnProperty("onboardingAssessmentType") &&
          onboardingODM.omniData.onboardingAssessmentType
        ) {
          yield put(
            Actions.setOnboardingAssessmentTypeRequest(
              onboardingODM.omniData.onboardingAssessmentType,
            ),
          );
        } else if (
          onboardingODM.organization.omniData.hasOwnProperty("defaultAsssesmentType") &&
          onboardingODM.organization.omniData.defaultAsssesmentType
        ) {
          //the default onboarding link is basically the only way to get here

          yield put(
            Actions.setOnboardingAssessmentTypeRequest(
              onboardingODM.organization.omniData.defaultAsssesmentType,
            ),
          );
        }

        if (onboardingODM.hasOwnProperty("organization") && onboardingODM.organization) {
          yield put(
            UserSessionActions.setThemeRequest(onboardingODM.organization.omniData.themeId),
          );
          yield put(Actions.setOrganizationODMSuccess(onboardingODM.organization));
        } else {
          yield put(
            Actions.onboardingSessionRequestFailed(
              "OmniDataAPI.loadOrganizationODM invalid OrganizationODM",
            ),
          );
        }
      } catch (error) {
        yield put(Actions.onboardingSessionRequestFailed(error));
      }

      yield put(Actions.setOnboardingODMRequest(onboardingODM));
      yield put(Actions.loadOnboardingODMSuccess());
    } else {
      //TODO defined an error return object so we can know more
      let onboardingStatus = {
        errorCode: onboardingODM.response.status,
        errorText: onboardingODM.response.data.detail,
      };
      yield put(Actions.setOnboardingStatusRequest(onboardingStatus));
    }
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setOnboardingODM({ payload }) {
  try {
    yield put(Actions.setOnboardingODMSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setOnboardingStatus({ payload }) {
  try {
    yield put(Actions.setOnboardingStatusSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setInviteKey({ payload }) {
  try {
    const selector = yield select(Actions.inviteKeySelector);

    yield put(Actions.setInviteKeySuccess(payload));
    if (selector !== payload) {
      yield put(Actions.loadOnboardingODMRequest(payload));
    }
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* onboardUser({ payload }) {
  try {
    let onboardingODM = payload.onboardingODM;
    let assessmentODM = payload.assessmentODM;
    let onboardingProctorODM = payload.onboardingProctorODM;
    let onboardingSubjectODM = payload.onboardingSubjectODM;
    let passiveOnboard = payload.passiveOnboard;

    // let proxyIsUser =  payload.onboardingODM
    let onboardingResponse = null;

    yield put(Actions.setOnboardingStatusRequest(null));

    if (onboardingODM.omniData.userType === constants.onboardingUserType.administrator) {
      onboardingResponse = yield call(OmniDataAPI.onboardAdministrator, onboardingODM);
    } else if (onboardingODM.omniData.userType === constants.onboardingUserType.provider) {
      onboardingResponse = yield call(OmniDataAPI.onboardProvider, onboardingODM);
    } else if (onboardingODM.omniData.userType === constants.onboardingUserType.partner) {
      onboardingResponse = yield call(OmniDataAPI.onboardPartner, onboardingODM);
    } else if (onboardingODM.omniData.userType === constants.onboardingUserType.patient) {
      yield put(Actions.onboardingSessionRequestFailed());
    }

    if (onboardingResponse != null && onboardingResponse.hasOwnProperty("response")) {
      let onboardingStatus = {
        errorCode: onboardingResponse.response.status,
        errorText: onboardingResponse.response.data.detail,
      };
      yield put(Actions.setOnboardingStatusRequest(onboardingStatus));

      //error case
    } else if (onboardingResponse != null) {
      yield put(Actions.onboardUserSuccess());

      if (passiveOnboard) {
        let onboardingStatus = {
          errorCode: "200",
          errorText: "User Onboarded Sucessfully",
        };
        yield put(Actions.setOnboardingStatusRequest(onboardingStatus));
      }

      if (!passiveOnboard) {
        const theReturn = yield call(
          [Auth, "signIn"],
          onboardingODM.omniData.credentials.username,
          onboardingODM.omniData.credentials.password,
        );

        yield delay(500);

        if (theReturn) {
          //save assessment and proxy useronboardUserRequest

          if (onboardingSubjectODM && assessmentODM) {
            let theID = theReturn.attributes["custom:userId"];

            let fakeProctorODM = { _id: theID, omniData: { partnerData: { yep: "true" } } };
            let newRelationship = null;

            if (
              onboardingSubjectODM.omniData.hasOwnProperty("isProxyPatient") &&
              onboardingSubjectODM.omniData.isProxyPatient
            ) {
              //this will be blank so lets marshal over all the shit we can
              onboardingSubjectODM.omniData.displayName = onboardingProctorODM.omniData.displayName;
              onboardingSubjectODM.omniData.givenName = onboardingProctorODM.omniData.givenName;
              onboardingSubjectODM.omniData.familyName = onboardingProctorODM.omniData.familyName;
              //these will have been established for for the onboardingProctorODM
              if (!onboardingSubjectODM.omniData.birthdate) {
                onboardingSubjectODM.omniData.birthdate = onboardingProctorODM.omniData.birthdate;
              }
              if (!onboardingSubjectODM.omniData.gender) {
                onboardingSubjectODM.omniData.gender = onboardingProctorODM.omniData.gender;
              }
              if (!onboardingSubjectODM.omniData.race) {
                onboardingSubjectODM.omniData.race = onboardingProctorODM.omniData.race;
              }
              if (!onboardingSubjectODM.omniData.ethnicity) {
                onboardingSubjectODM.omniData.ethnicity = onboardingProctorODM.omniData.ethnicity;
              }

              onboardingSubjectODM.omniData.email = onboardingProctorODM.omniData.email;
              onboardingSubjectODM.omniData.mobilePhone = onboardingProctorODM.omniData.mobilePhone;

              newRelationship = createNewUserRelationship(
                fakeProctorODM,
                constants.omniRelationshipTypes.proxyPatient,
              );
              onboardingSubjectODM.omniRelationships.relatedData.push(newRelationship);
              //prefer to delete but test this later, doesn't hurt for now to leave it out
              // delete onboardingSubjectODM.omniData.isProxyPatient;
            }

            newRelationship = createNewUserRelationship(
              fakeProctorODM,
              constants.omniRelationshipTypes.patientPartner,
            );
            onboardingSubjectODM.omniRelationships.relatedData.push(newRelationship);

            console.log(
              `Count of symptoms ${onboardingSubjectODM.omniData.patientData.symptomODMs.length}`,
            );
            let newPatientODM = yield call(OmniDataAPI.createPatient, onboardingSubjectODM);

            if (newPatientODM) {
              yield put(PartnerSession.reflectUpdatedPatientODMRequest(newPatientODM));

              let assessmentRelationships = assessmentODM.omniRelationships.relatedData.slice();

              //Subject, newPatientODM is a patientODM, FYI
              let assessmentRelationship = createNewUserRelationship(
                newPatientODM,
                constants.omniRelationshipTypes.assessmentSubject,
              );
              assessmentRelationships.push(assessmentRelationship);
              // props.partnerReflectUpdatedPatientODMRequest(theReturn);

              //Proctor
              assessmentRelationship = createNewUserRelationship(
                fakeProctorODM,
                constants.omniRelationshipTypes.assessmentProctor,
              );
              assessmentRelationships.push(assessmentRelationship);

              //set relationships
              assessmentODM.omniRelationships.relatedData = assessmentRelationships;

              yield put(AssessmentSession.updateAssessmentRequest(assessmentODM));
            }
          }
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      }
    }
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* unsubscribeUser({ payload }) {
  try {
    let unsubscribeResponse = yield call(OmniDataAPI.unsubscribeUser, payload);

    if (unsubscribeResponse != null && unsubscribeResponse.hasOwnProperty("response")) {
      //error case
      yield put(
        Actions.setUnsubscribeStatusRequest(
          `${unsubscribeResponse.response.status} - ${unsubscribeResponse.response.data.detail}`,
        ),
      );
    } else if (unsubscribeResponse != null) {
      yield put(Actions.unsubscribeUserSuccess());
    } else {
      yield put(
        Actions.setUnsubscribeStatusRequest("Error, please check your internet connection."),
      );
    }
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setUnsubscribeStatus({ payload }) {
  try {
    yield put(Actions.setUnsubscribeStatusSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setAssesssmentODM({ payload }) {
  try {
    yield put(Actions.setAssesssmentODMSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setOnboardingProctorODM({ payload }) {
  try {
    yield put(Actions.setOnboardingProctorODMSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setOnboardingSubjectODM({ payload }) {
  try {
    yield put(Actions.setOnboardingSubjectODMSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

export function* setOnboardingAssessmentType({ payload }) {
  try {
    yield put(Actions.setOnboardingAssessmentTypeSuccess(payload));
  } catch (error) {
    yield put(Actions.onboardingSessionRequestFailed());
  }
}

//  saga
export default function* onboardingSessionSaga() {
  yield takeLatest(Actions.loadOnboardingODMRequest, loadOnboardingODM);
  yield takeLatest(Actions.setOnboardingODMRequest, setOnboardingODM);
  yield takeLatest(Actions.setOnboardingStatusRequest, setOnboardingStatus);
  yield takeLatest(Actions.setInviteKeyRequest, setInviteKey);
  yield takeLatest(Actions.onboardUserRequest, onboardUser);
  yield takeLatest(Actions.unsubscribeUserRequest, unsubscribeUser);
  yield takeLatest(Actions.setUnsubscribeStatusRequest, setUnsubscribeStatus);
  yield takeLatest(Actions.setAssesssmentODMRequest, setAssesssmentODM);
  yield takeLatest(Actions.setOnboardingProctorODMRequest, setOnboardingProctorODM);
  yield takeLatest(Actions.setOnboardingSubjectODMRequest, setOnboardingSubjectODM);
  yield takeLatest(Actions.setOnboardingAssessmentTypeRequest, setOnboardingAssessmentType);
}
